import React from 'react';

interface Security2FAWarningProps {
  onSetup2FA?: () => void;
  onDismiss?: () => void;
  sticky?: boolean;
  sidebarCollapsed?: boolean;
  message?: string;
}

const Security2FAWarning: React.FC<Security2FAWarningProps> = ({ onSetup2FA, onDismiss, sticky, sidebarCollapsed, message }) => {
  const handleClick = () => {
    if (onSetup2FA) {
      onSetup2FA();
    } else {
      window.dispatchEvent(new CustomEvent('openAccountSettingsTutorial'));
    }
  };

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onDismiss) {
      onDismiss();
    }
  };

  // Build className for fixed mode with sidebar-aware left offset (matching Header pattern)
  const fixedClasses = sticky
    ? 'w-full'
    : `fixed top-[64px] left-0 right-0 ${
        sidebarCollapsed === undefined
          ? ''
          : sidebarCollapsed
            ? 'lg:left-0'
            : 'lg:left-[296px]'
      } transition-all duration-300`;

  return (
    <div
      onClick={handleClick}
      className={`bg-[#FEF3F2] border-b border-[#FECDCA] px-4 py-2 flex items-center justify-center gap-3 cursor-pointer hover:bg-[#FEE4E2] ${fixedClasses}`}
      style={{ 
        position: sticky ? 'sticky' : undefined,
        top: sticky ? '64px' : undefined,
        zIndex: 20,
        height: '36px',
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M12 8v4m0 4h.01" />
      </svg>
      <span className="text-[13px] font-medium text-[#B42318]">
        {message || <>Your account is not fully secured. <span className="underline">Enable 2FA now</span></>}
      </span>
      {onDismiss && (
        <button
          onClick={handleDismiss}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-[#FECDCA] transition-colors"
          title="Dismiss"
          style={{ lineHeight: 0 }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6L6 18" />
            <path d="M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default Security2FAWarning;
